export const selectMicroSurveyUnfollowTags = (store: any) => {
  return store?.microsurvey?.unfollowTags ?? []
}
